import PaintSalesWorkspace from '../../placeholders/PaintSalesWorkspace';

export default PaintSalesWorkspace;
